var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12c0,-6.62742 5.37258,-12 12,-12c6.62742,0 12,5.37258 12,12c0,6.62742 -5.37258,12 -12,12c-6.62742,0 -12,-5.37258 -12,-12zM10.58579,12l-3.29289,3.29289c-0.39052,0.39052 -0.39052,1.02369 0,1.41421c0.39052,0.39052 1.02369,0.39052 1.41421,0l3.29289,-3.29289l3.29289,3.29289c0.39052,0.39052 1.02369,0.39052 1.41421,0c0.39052,-0.39052 0.39052,-1.02369 0,-1.41421l-3.29289,-3.29289l3.29289,-3.29289c0.39052,-0.39052 0.39052,-1.02369 0,-1.41421c-0.39052,-0.39052 -1.02369,-0.39052 -1.41421,0l-3.29289,3.29289l-3.29289,-3.29289c-0.39052,-0.39052 -1.02369,-0.39052 -1.41421,0c-0.39052,0.39052 -0.39052,1.02369 0,1.41421z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(170, 170, 170)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-167293505277441955",
    d: "M0,12c0,-6.62742 5.37258,-12 12,-12c6.62742,0 12,5.37258 12,12c0,6.62742 -5.37258,12 -12,12c-6.62742,0 -12,-5.37258 -12,-12zM10.58579,12l-3.29289,3.29289c-0.39052,0.39052 -0.39052,1.02369 0,1.41421c0.39052,0.39052 1.02369,0.39052 1.41421,0l3.29289,-3.29289l3.29289,3.29289c0.39052,0.39052 1.02369,0.39052 1.41421,0c0.39052,-0.39052 0.39052,-1.02369 0,-1.41421l-3.29289,-3.29289l3.29289,-3.29289c0.39052,-0.39052 0.39052,-1.02369 0,-1.41421c-0.39052,-0.39052 -1.02369,-0.39052 -1.41421,0l-3.29289,3.29289l-3.29289,-3.29289c-0.39052,-0.39052 -1.02369,-0.39052 -1.41421,0c-0.39052,0.39052 -0.39052,1.02369 0,1.41421z",
    vectorEffect: "non-scaling-stroke"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bcfc8425dd24ac9d23d5bd644109bb37.svg";
export { ForwardRef as ReactComponent };